module.exports = __webpack_public_path__ + "static/2front-mobile-2-317a71bcdf7542ce76dbefa6e4753307.png";